<template>
  <div>
    <b-card
      style="width: 1000px; margin-left: 230px; margin-top: 50px"
      header="Reprocess Payment"
    >
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row style="margin-left: 190px">
          <v-col>
            <v-text-field
              v-model.number="form.amount"
              type="number"
              label="Amount"
              :rules="[rules.required, rules.positive]"
              required
              style="width: 500px"
            />
            <v-text-field
              v-model="form.txnId"
              label="Transaction ID"
              :rules="[rules.required]"
              required
              style="width: 500px"
            />
            <v-select
              v-model="form.pgName"
              :items="pgOptions"
              item-text="text"
              item-value="value"
              label="Payment Gateway"
              :rules="[rules.required]"
              clearable
              required
              style="width: 500px"
            />
            <v-select
              v-model="form.userType"
              :items="userTypes"
              item-text="text"
              item-value="value"
              label="User Type"
              :rules="[rules.required]"
              clearable
              required
              style="width: 500px"
            />
            <v-text-field
              v-model="form.userId"
              label="User ID"
              :rules="[rules.required]"
              required
              style="width: 500px"
            />
          </v-col>
        </v-row>
        <v-btn text :disabled="submitting" @click="resetForm">Reset</v-btn>
        <v-btn
          class="primary mr-4"
          :loading="submitting"
          :disabled="submitting"
          style="color: white"
          @click="onSubmitClick"
        >
          Reprocess
        </v-btn>
      </v-form>
    </b-card>

    <!-- Confirm dialog -->
    <v-dialog v-model="dialog" max-width="520px" persistent>
      <v-card>
        <v-card-text>
          <v-container
            style="background: rgb(130, 164, 192) 11.2%; color: white"
          >
            Are you sure you want to reprocess this payment?
          </v-container>
          <div class="pa-4">
            <div><strong>Amount:</strong> {{ form.amount }} INR</div>
            <div><strong>Transaction Id:</strong> {{ form.txnId }}</div>
            <div><strong>PgName:</strong> {{ form.pgName }}</div>
            <div><strong>UserType:</strong> {{ form.userType }}</div>
            <div><strong>UserId:</strong> {{ form.userId }}</div>
          </div>
        </v-card-text>

        <v-card-actions class="ml-12">
          <v-btn class="ml-12" color="blue darken-1" text @click="close">
            Cancel
          </v-btn>
          <v-btn
            class="ml-12"
            color="warning darken-1"
            text
            :loading="submitting"
            :disabled="submitting"
            @click="confirmSubmit"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// If you already have a service, import it and wire below.
// Example:
import { reprocessPayment } from "@/services/planchannelmapping";

import { extractError } from "../utils/error";

export default {
  data() {
    return {
      valid: false,
      dialog: false,
      submitting: false,
      form: {
        amount: null,
        txnId: "",
        pgName: null,
        userType: null,
        userId: "",
      },
      pgOptions: [
        { text: "EASEBUZZ", value: "EASEBUZZ" },
        { text: "PAYTM", value: "PAYTM" },
      ],
      userTypes: [
        { text: "CUSTOMER", value: "CUSTOMER" },
        { text: "LCO", value: "LCO" },
      ],
      rules: {
        required: (v) => !!v || v === 0 || "Required",
        positive: (v) => Number(v) > 0 || "Must be greater than 0",
      },
    };
  },
  methods: {
    onSubmitClick() {
      const ok = this.$refs.form.validate();
      if (ok) this.dialog = true;
    },
    async confirmSubmit() {
      try {
        this.submitting = true;

        // Build the payload exactly as requested
        const payload = {
          amount: Number(this.form.amount),
          orderId_trnsaxnId: this.form.txnId.trim(),
          pgName: this.form.pgName,
          userType: this.form.userType,
          userId: this.form.userId.trim(),
        };

        // Call your API here:
        // const { data } = await reprocessPayment(payload);

        // --- demo stub (remove this when wiring real API) ---
        const resp = await reprocessPayment(payload);

        this.dialog = false;
        if (
          resp.data.response &&
          resp.data.response.result &&
          resp.data.response.result.errorCode == "00"
        ) {
          this.$toasted.success(
            (resp.data.response &&
              resp.data.response.result &&
              resp.data.response.result.message) ||
              "Payment processed successfully",
            {
              duration: 2000,
            }
          );
        } else {
          this.$showError(
            (resp.data.response &&
              resp.data.response.result &&
              resp.data.response.result.message) ||
              "Something went wrong"
          );
          return;
        }

        // If you want to use the response, handle `data` here
        this.resetForm();
      } catch (err) {
        const message = extractError(err);
        this.$showError ? this.$showError(message) : alert(message);
      } finally {
        this.submitting = false;
      }
    },
    close() {
      this.dialog = false;
    },
    resetForm() {
      this.form = {
        amount: null,
        txnId: "",
        pgName: null,
        userType: null,
        userId: "",
      };
      this.$nextTick(() => this.$refs.form.resetValidation());
    },
  },
};
</script>

<style scoped>
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  background-image: linear-gradient(
    159.6deg,
    rgb(130, 164, 192) 11.2%,
    rgb(40, 118, 156) 100.2%
  );
  color: white;
}
.v-application .ml-12 {
  margin-left: 1.7cm !important;
}
.v-dialog > .v-card > .v-card__text {
  padding: 0 0px 0px;
}
</style>
